import { DesignToken } from "@livechat/design-system-react-components";

import { ReportDistribution } from "constants/reports/distribution";
import { ILast7DaysReportData } from "store/views/reports/interfaces";
import { withVar } from "themes/helpers";

import { getSeriesDataFromPeriod, sumValueFromPeriod } from "../helpers";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deserializeLast7Days(data: any): ILast7DaysReportData {
  const ticketsData = data.data;
  const newTicketsKeys = Object.keys(ticketsData.newTickets).sort();
  const newTicketsKeysBefore = Object.keys(ticketsData.newTicketsBefore).sort();
  const ticketsSatisfactionKeys = Object.keys(ticketsData.ticketsSatisfaction).sort();
  const ticketsSatisfactionKeysBefore = Object.keys(ticketsData.ticketsSatisfactionBefore).sort();

  const newTicketsData = newTicketsKeys.map(date => ticketsData.newTickets[date]);
  const newTicketsDataBefore = newTicketsKeysBefore.map(date => ticketsData.newTicketsBefore[date]);
  const ticketsSatisfaction = ticketsSatisfactionKeys.map(date => ticketsData.ticketsSatisfaction[date]);
  const ticketsSatisfactionBefore = ticketsSatisfactionKeysBefore.map(
    date => ticketsData.ticketsSatisfactionBefore[date]
  );

  const newTickets = sumValueFromPeriod(newTicketsData, "newTickets");
  const newTicketsWeekBefore = sumValueFromPeriod(newTicketsDataBefore, "newTickets");
  const newTicketsDifference = newTickets - newTicketsWeekBefore;

  const ticketRatingsGreat = sumValueFromPeriod(ticketsSatisfaction, "good");
  const ticketRatingsGreatBefore = sumValueFromPeriod(ticketsSatisfactionBefore, "good");
  const ticketRatingsOkay = sumValueFromPeriod(ticketsSatisfaction, "neutral");
  const ticketRatingsOkayBefore = sumValueFromPeriod(ticketsSatisfactionBefore, "neutral");
  const ticketRatingsBad = sumValueFromPeriod(ticketsSatisfaction, "bad");
  const ticketRatingsBadBefore = sumValueFromPeriod(ticketsSatisfactionBefore, "bad");
  const ticketRatingsTotal = ticketRatingsGreat + ticketRatingsOkay + ticketRatingsBad;
  const ticketRatingsTotalBefore = ticketRatingsGreatBefore + ticketRatingsOkayBefore + ticketRatingsBadBefore;

  const ticketRatingsGreatDifference = Math.round(
    (ticketRatingsGreat / ticketRatingsTotal - ticketRatingsGreatBefore / ticketRatingsTotalBefore) * 100
  );
  const ticketRatingsOkayDifference = Math.round(
    (ticketRatingsOkay / ticketRatingsTotal - ticketRatingsOkayBefore / ticketRatingsTotalBefore) * 100
  );
  const ticketRatingsBadDifference = Math.round(
    (ticketRatingsBad / ticketRatingsTotal - ticketRatingsBadBefore / ticketRatingsTotalBefore) * 100
  );

  const { solvedTickets } = ticketsData;
  const { closedTickets } = ticketsData;
  const { averageFirstResponseTime } = ticketsData;

  return {
    newTickets,
    newTicketsDifference,
    ticketRatingsGreat,
    ticketRatingsGreatDifference,
    ticketRatingsOkay,
    ticketRatingsOkayDifference,
    ticketRatingsBad,
    ticketRatingsBadDifference,
    solvedTickets,
    closedTickets,
    averageFirstResponseTime,
    chart: {
      summary: [
        {
          value: newTickets,
        },
      ],
      labels: newTicketsKeys,
      series: [
        {
          color: withVar(DesignToken.DecorGreen500),
          data: getSeriesDataFromPeriod(newTicketsData, "newTickets", ReportDistribution.Day),
        },
      ],
    },
  };
}
